// /src/toolkitServices/productApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const productApi = createApi({
  reducerPath: "productApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["Product"],
  endpoints: (builder) => ({
    addProduct: builder.mutation({
      query: (data) => ({
        url: "/products/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Product"],
    }),

    // list with optional filters (search, active, category)
    getAllProducts: builder.query({
      query: ({ page = 1, limit = 1000, search = "", active, category } = {}) => {
        const params = { page, limit, q: search };
        if (typeof active === "boolean") params.active = active;
        if (category) params.category = category; // id or name
        return { url: "/products/", params };
      },
      providesTags: ["Product"],
    }),

    // fetch one
    getProductById: builder.query({
      query: (id) => `/products/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Product", id }],
    }),

    // update
    updateProduct: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/products/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Product"],
    }),

    // (optional) activate/deactivate used on list
    activateProduct: builder.mutation({
      query: (id) => ({ url: `/products/${id}/activate`, method: "PATCH" }),
      invalidatesTags: ["Product"],
    }),
    deactivateProduct: builder.mutation({
      query: (id) => ({ url: `/products/${id}/deactivate`, method: "PATCH" }),
      invalidatesTags: ["Product"],
    }),

    
  }),
});

export const {
  useAddProductMutation,
  useGetAllProductsQuery,
  useGetProductByIdQuery,
  useUpdateProductMutation,
  useActivateProductMutation,
  useDeactivateProductMutation,
  
} = productApi;

export default productApi;
